import gql from "graphql-tag";

export const GET_CHAMPION_OTP_STATS = gql`
  query getChampionOtpStats($championId: Int!) {
    getChampionOtpStats(championId: $championId) {
      gamesPlayed
      iconId
      lp
      regionId
      summonerName
      tier
      rank
      winRate
    }
  }
`;

export const GET_CHAMPION_OTP_STATS2 = gql`
  query getChampionOtpStats2($championId: Int!, $regionId: String!) {
    getChampionOtpStats2(championId: $championId, regionId: $regionId) {
      gamesPlayed
      iconId
      lp
      regionId
      summonerName
      tier
      rank
      winRate
    }
  }
`;
